import { module } from 'modujs';
import $ from 'jquery';
import gsap from 'gsap';

export default class extends module {
    constructor(m)
    {
        super(m);
        this.$video = $('.videoPopin');
        this.events = {
            click: {
                open: 'openVideo',
            },
        }

    }

    init()
    {

        if ($('.videoPopin').length === 0) {
            $('#app').append('<div class="videoPopin">' +
                '<div class="videoPopin__overlay"></div>' +
                '<div class="videoPopin__content">' +
                '<video src="" controls></video>' +
                '</div>' +
                '<div class="videoPopin__close customCursor" data-cursor="glass">' +
                '<span></span>' +
                '<span></span>' +
                '</div>' +
                '</div>')
        }

        //trouver une autre façon de faire
        $('#app').on('click', '.videoPopin__close', () => {
            this.closeVideo()
        })
    }

    openVideo()
    {
        let videoPath = this.el.dataset.urlvideo;
        console.log('openVideo : ' + videoPath);

        let video = this.$video.find('video');

        $(video).attr('src', videoPath);
        gsap.to(this.$video, 1, {xPercent: -100, ease: 'Expo.easeInOut'});
        gsap.fromTo('.videoPopin__overlay', 1, {skewX: 2, xPercent: 5}, {skewX: 0, xPercent: -100, ease: 'Expo.easeInOut', delay: 0.5});
        $(video).get(0).play();


    }

    closeVideo()
    {
        console.log('click close');
        let video = this.$video.find('video');
        $(video).get(0).pause();
        gsap.fromTo('.videoPopin__overlay', 1, {skewX: 2}, {skewX: 0, xPercent: 0, ease: 'Expo.easeInOut'});
        gsap.to(this.$video, 1, {xPercent: 0, ease: 'Expo.easeInOut', delay: 0.5});
    }
}




// WEBPACK FOOTER //
// ./scripts/modules/videoPopin.js